<template>
  <div v-loading="loading" class="archiving-tx-detail">
    <common-bg-plate>
      <el-alert
        title="注意"
        type="warning"
        description="归档数据已加密，显示信息为密文"
        :closable="false"
        show-icon
      >
      </el-alert>
      <detail-table :title="title1" :table-col="tableCol1" :list="list1"></detail-table>
      <detail-table :title="title2" :table-col="tableCol2" :list="list2"></detail-table>
      <detail-table :title="title3" :table-col="tableCol3" :list="list3">
        <template slot="paramsDetail">
          <param-table :head-list="labelList" :list="paramList"></param-table>
        </template>
      </detail-table>
    </common-bg-plate>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import timeImg from '@/assets/images/tableIcon/time.png'
import hashImg from '@/assets/images/tableIcon/hash.png'
import heightImg from '@/assets/images/tableIcon/height.png'
import organizationImg from '@/assets/images/tableIcon/organization.png'
import statusImg from '@/assets/images/tableIcon/status-icon.png'
import startUserImg from '@/assets/images/tableIcon/start-user.png'
import idIconImg from '@/assets/images/tableIcon/id-icon.png'
import txTypeImg from '@/assets/images/tableIcon/tx-type.png'
import targetImg from '@/assets/images/tableIcon/target.png'
import resultImg from '@/assets/images/tableIcon/result.png'
import methodImg from '@/assets/images/tableIcon/method.png'
import paramsImg from '@/assets/images/tableIcon/params.png'
import contractHashImg from '@/assets/images/tableIcon/contract-hash.png'
const Base64 = require('js-base64').Base64
export default {
  name: 'ArchivingTxnDetail',
  components: {},
  data() {
    return {
      timeImg,
      title1: '所属区块信息',
      tableCol1: [
        { label: '区块Hash', icon: hashImg, value: 'BlockHash' },
        { label: '区块高度', icon: heightImg, value: 'blockHeight' }
      ],
      list1: {
        BlockHash: '',
        blockHeight: ''
      },
      title2: '交易信息',
      tableCol2: [
        { label: '交易id', icon: idIconImg, value: 'txId' },
        { label: '交易发送组织', icon: organizationImg, value: 'orgId' },
        { label: '交易状态', icon: statusImg, value: 'txStatusCode' },
        { label: '交易发起用户', icon: startUserImg, value: 'sender' },
        { label: '交易类型', icon: txTypeImg, value: 'txType' },
        { label: '交易发起时间', icon: timeImg, value: 'createAt' }
      ],
      list2: {
        txId: '',
        orgId: '',
        txStatusCode: '',
        sender: '',
        txType: '',
        createAt: ''
      },
      title3: '合约执行信息',
      tableCol3: [
        { label: '合约目标', icon: targetImg, value: 'contractName' },
        {
          label: '合约调用入参',
          icon: paramsImg,
          value: 'contractName',
          slotName: 'paramsDetail',
          className: 'params-detail'
        },
        { label: '合约读写集哈希', icon: contractHashImg, value: 'rwSetHash' },
        {
          label: '合约执行结果码',
          icon: resultImg,
          value: 'contractResultCode',
          offset: 12,
          pull: 12
        },
        { label: '合约调用方法', icon: methodImg, value: 'contractMethod', offset: 12, pull: 12 }
      ],
      list3: {
        contractName: '',
        rwSetHash: '',
        contractResultCode: '',
        contractMethod: ''
      },
      labelList: [
        { label: '#', prop: 'id', minWidth: 68 },
        { label: 'Key', prop: 'key', minWidth: 173 },
        { label: 'Value', prop: 'value', minWidth: 180 }
      ],
      paramList: [],
      loading: true
    }
  },
  computed: {
    ...mapState({
      detail: state => state.chain.archiving_info
    })
  },
  mounted() {
    this.getTxnListFn()
  },
  methods: {
    getTxnListFn() {
      let self = this
      let params2 = {
        tx_id: self.$route.query.txId,
        chainid: self.$route.query.chainId,
        db_info: self.detail.db_info
      }
      self.$apis.chain
        .queryTx(params2)
        .then(data => {
          if (!data.errors) {
            let result = JSON.parse(data.data)
            self.list1.BlockHash = result.block_hash
            self.list1.blockHeight = result.block_height

            let tx = result.transaction
            self.list2.txId = tx.payload.tx_id
            self.list2.orgId = tx.sender.signer.org_id
            self.list2.txStatusCode = tx.result.code
            self.list2.sender = self.$constants.EMPTY
            self.list2.txType = tx.payload.method
            self.list2.createAt = self.formatTime(tx.payload.timestamp)

            self.list3.contractName = tx.payload.contract_name
            self.list3.rwSetHash = tx.result.rw_set_hash
            self.list3.contractResultCode = tx.result.contract_result.code
            self.list3.contractMethod = tx.payload.method

            self.paramList = tx.payload.parameters
            this.loading = false
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('archiving-tx-detail', (), ());
.archiving-tx-detail {
  @include adaptation(
    (
      --archiving-tx-detail-common-bg-plate-padding: 16px 16px 0,
      --archiving-tx-detail-detail-section-padding: 4px 0,
      --archiving-tx-detail-contract-params-height: 70px
    )
  );

  .common-bg-plate {
    min-height: var(--base-main-router-body-avaliable-height);
    padding: var(--archiving-tx-detail-common-bg-plate-padding);
  }

  .cbaas-detail-table {
    /deep/ .cbaas-detail-section {
      padding: var(--archiving-tx-detail-detail-section-padding);

      .el-col.params-detail {
        height: var(--archiving-tx-detail-contract-params-height);
        .detail-item {
          .right {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
